import { useState } from 'react'
import type { JSX } from 'react'

import { useAccountSetSettings } from '~publish/legacy/ai/hooks/useAccountSetSettings'

import { Button } from '../Button'
import styles from './Onboarding.module.css'
import { Progress } from './Progress'
import { SlideView } from './SlideView'
import loaderStyles from '../Loader.module.css'
import { LoaderAnimation } from '../LoaderAnimation'

function OnboardingBody(): JSX.Element {
  const [currentSlide, setCurrentSlide] = useState(1)
  const [isSavingSettings, setIsSavingSettings] = useState(false)

  const { accountSetSettings } = useAccountSetSettings()

  const viewingFinalSlide = currentSlide === 4

  if (isSavingSettings) {
    return (
      <div className={loaderStyles.wrapper}>
        <LoaderAnimation />
        <p className={loaderStyles.message}>Setting things up</p>
      </div>
    )
  }

  return (
    <div className={styles.bodyWrapper}>
      <SlideView currentSlide={currentSlide} />
      <Progress currentSlide={currentSlide} />
      <Button
        disabled={false}
        secondary={false}
        onClick={(): void => {
          setCurrentSlide(currentSlide + 1)

          if (viewingFinalSlide) {
            // Save account settings...
            accountSetSettings({
              variables: {
                settings: {
                  aiSettings: {
                    onboarded: true,
                  },
                },
              },
            })

            setIsSavingSettings(true)
          }
        }}
        fullWidth
      >
        {viewingFinalSlide ? 'Got It' : 'Next'}
      </Button>
    </div>
  )
}

export { OnboardingBody }
